export default __webpack_public_path__ + "static/media/IconDesc_C_Inv_Ramp_8x4_01.256.b97e497f.png";